import { ReactNode, forwardRef } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {
  Typography,
  TypographyProps,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

import { useDialogContext } from './context';

const styles = createStyles({
  root: {},
});

export interface TitleProps
  extends Omit<TypographyProps, 'classes'>,
    WithStyles<typeof styles> {
  children: ReactNode;
}

export const Title = forwardRef<HTMLDivElement, TitleProps>(
  ({ children, className, classes, ...rest }, ref) => {
    const { id } = useDialogContext();

    return (
      <Typography
        id={`${id}-title`}
        variant="h4"
        component="div"
        ref={ref}
        className={classNames(classes.root, className)}
        {...rest}
      >
        {children}
      </Typography>
    );
  },
);

Title.displayName = 'DialogComposite.Title';

export default withStyles(styles)(Title);
